import cookie from 'js-cookie'

export default (Vue) => {
  return Promise.all([
    Vue.$store.dispatch('setMe'),
    Vue.$store.dispatch('selectAccounts'),
    Vue.$store.dispatch('setResources')
  ])
  .then(result => {
    const accounts = result[1]
    const selectedAccountId = cookie.get('selected_account_id')
    const account = accounts.find(v => v._id === selectedAccountId) || accounts[0]

    if (account && account._id) {
      return Vue.$store.dispatch('selectAccount', account._id).catch(() => {
        Vue.$router.push('/auth')
      })
    } else {
      Vue.$router.push('/my-account') // Não há contas
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/Bootstrapping.js